import { combineReducers, configureStore } from '@reduxjs/toolkit'
import spotsReducer from '../features/map/spotSlice'
import settingsReducer from '../features/settings/settingsSlice'
/*
import storage from 'redux-persist/lib/storage'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist'

const persistConfig = {
  key: 'root',
  version: 1,
  whitelist: ['settings'],
  blacklist: ['settings.ui', 'settings.timeRange', 'settings.reportRange'],
  storage
}

const persistedReducer = persistReducer(persistConfig, combineReducers())
*/

export const store = configureStore({
  reducer: {
    spots: spotsReducer,
    settings: settingsReducer
  }/*
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
    */
})
